// extracted by mini-css-extract-plugin
module.exports = {"privacyPolicyText":"NtbLB2UIaaXstETmf7fWR"};